module.exports = __webpack_public_path__ + "img/map_18.b5fec4eb.png";